import { useContext } from 'react';
import { useFilterFamilyOptions } from '../../hooks/useFilterFamilyOptions';
import { useObjectTypeSelect } from '../../hooks/useObjectTypeSelect';
import { useSelectOnlyFilterFamilyAndField } from '../../hooks/useSelectOnlyFilterFamilyAndField';
import EditorConditionFieldSelectPanel from './EditorConditionFieldSelectPanel';
import EditorFilterFamilySelectPanel from './EditorFilterFamilySelectPanel';
import EditorGroupedFilterFamilySelectPanel from './EditorGroupedFilterFamilySelectPanel';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterFamilyAndFieldSelectContainer = styled.div.withConfig({
  displayName: "EditorFilterFamilyAndFieldSelect__EditorFilterFamilyAndFieldSelectContainer",
  componentId: "sc-17sex5m-0"
})(["display:flex;height:100%;"]);
const EditorFilterFamilyAndFieldSelect = () => {
  const {
    selectedFilterFamily,
    selectedFilterFamilyGroup
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    hasOnlyOneFilterFamilyOption
  } = useFilterFamilyOptions();
  const {
    hasOnlyOneOption: hasOnlyOneObjectTypeOption
  } = useObjectTypeSelect();
  const shouldSkipFilterFamilySelect = hasOnlyOneFilterFamilyOption && hasOnlyOneObjectTypeOption;
  useSelectOnlyFilterFamilyAndField();
  return /*#__PURE__*/_jsxs(EditorFilterFamilyAndFieldSelectContainer, {
    children: [!shouldSkipFilterFamilySelect && /*#__PURE__*/_jsx(EditorFilterFamilySelectPanel, {}), selectedFilterFamily && /*#__PURE__*/_jsx(EditorConditionFieldSelectPanel, {
      filterFamily: selectedFilterFamily.filterFamily
    }), !selectedFilterFamily && selectedFilterFamilyGroup && /*#__PURE__*/_jsx(EditorGroupedFilterFamilySelectPanel, {})]
  });
};
export default EditorFilterFamilyAndFieldSelect;